import type {ClientStatusPublic} from '@wix/cashier-common/dist/src/types/PaymentStatus'
import {DONATION_ERROR} from './donation-error'

export const ROOT_COMPONENT_ID = 'events-details-page-root'

export const WarmupStateKey = 'EventsPageInitialState'
export const EventSlugQueryOverrideParam = 'event-slug-override'

export const FORM_VIEW_STATE = 'form-view-state'

export enum UserRole {
  ADMIN = 'Admin',
  MEMBER = 'Member',
  Visitor = 'Visitor',
}

export enum FormStep {
  BuyerDetails = 'form',
  TicketsDetails = 'ticketsDetails',
  Policies = 'policies',
  Payment = 'payment',
}

export const CHECKOUT_STEPS = [FormStep.BuyerDetails, FormStep.TicketsDetails, FormStep.Policies, FormStep.Payment]

export const RSVP_STEPS = [FormStep.BuyerDetails, FormStep.Policies]

export interface SettingsEvents {
  navigate: DetailsSettingsNavigateActions
}

export enum DetailsPageSettingsEventsKeys {
  Navigate = 'navigate',
}

export enum DetailsSettingsNavigateActions {
  details = 'details',
  form = 'form',
}

export enum SEATING_ERROR {
  TICKET_LIMIT_REACHED = 'TICKET_LIMIT_REACHED',
  PLACE_CAPACITY_REACHED = 'PLACE_CAPACITY_REACHED',
}

export interface SeatingErrors {
  error: SEATING_ERROR
  planPlaceId: string
  donationErrors: Record<string, DONATION_ERROR>
}

export enum RESERVATION_ERROR {
  SOMETHING_WENT_WRONG = 'SOMETHING_WENT_WRONG',
  PLACE_RESERVED = 'PLACE_RESERVED',
}

export const confirmPaymentSuccessStatuses: ClientStatusPublic[] = ['Approved', 'Pending', 'InProcess']

export const RSVP_FORM_HEADER_ID = 'fa8b95f5-c94f-4dac-72be-b9230626f426'
export const RSVP_FORM_SUBMIT_BUTTON_ID = '8dc878eb-9fe0-4581-8203-5c1ecff5d348'

export const BUYER_FORM_HEADER_ID = '8ccbadb3-b052-416f-4492-8135121b8ba0'
export const BUYER_FORM_SUBMIT_BUTTON_ID = '75db23eb-410b-4b6e-4cdf-551d3c656032'

export const TICKET_HOLDER_FORM_HEADER_ID = '53830715-00d5-44ef-488c-13dbb4d8db0d'
export const TICKET_HOLDER_FORM_SUBMIT_BUTTON_ID = '81ff6897-67ba-40d4-fbf4-9250dff89e79'
